import styled from 'styled-components';
import { UploadButtonProps } from './uploadButton.types';

export const UploadButtonContainer = styled.div<UploadButtonProps>`
  input {
    display: none;
  }
`;
